// Shared post-login step for every sign-in method (password, OTP, magic link):
// persist the session the way PrivateRoute/authHeader expect, then redirect
// by role. Mirrors the logic LoginTab used to inline for password login only.
export function completeLogin(navigate, data) {
  localStorage.setItem('login', JSON.stringify(true));
  localStorage.setItem('token', data.token);

  if (data.user) {
    localStorage.setItem('userEmail', data.user.email);
    localStorage.setItem('userId', data.user.id);
    localStorage.setItem('userRole', data.user.role);

    const fullName = [data.user.firstname, data.user.lastname]
      .filter(Boolean)
      .join(' ') || data.user.username || data.user.email;
    localStorage.setItem('userName', fullName);
  }

  const role = (data.user?.role || '').toLowerCase();
  navigate(role === 'customer' ? '/customer/dashboard' : '/dashboard');
}
